import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";
import { fileUrl } from "@/lib/api";

export default function BeforeAfterSlider({ before, after, className = "" }) {
  return (
    <div className={`relative overflow-hidden rounded-xl ${className}`} data-testid="before-after-slider">
      <ReactCompareSlider
        itemOne={
          <ReactCompareSliderImage src={fileUrl(before)} alt="Before" style={{ objectFit: "cover" }} />
        }
        itemTwo={
          <ReactCompareSliderImage src={fileUrl(after)} alt="After" style={{ objectFit: "cover" }} />
        }
        style={{ height: "100%", width: "100%" }}
      />
      <span className="pointer-events-none absolute top-3 left-3 rounded-full bg-slate-900/80 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white z-10">Before</span>
      <span className="pointer-events-none absolute top-3 right-3 rounded-full bg-green-600 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white z-10">After</span>
    </div>
  );
}
